module.exports = __webpack_public_path__ + "img/Weapon_201.1a936662.png";